<template>
  <div class="edit-page">
    <div class="back" @click="goBack">
      <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
    </div>

    <div class="edit-content">
      <div class="page-title">上传事故报告</div>

      <div class="info-section">
        <div class="section-title">事故基本信息</div>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">车辆编码</span>
            <span class="value">{{ accidentInfo.licenceNo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">测试/运营主体</span>
            <span class="value">{{ accidentInfo.deptName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">车辆识别码</span>
            <span class="value">{{ accidentInfo.vin || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">事故类型</span>
            <span class="value">{{ getAccidentTypeText(accidentInfo.accidentType) }}</span>
          </div>
          <div class="info-item">
            <span class="label">事故发生地点</span>
            <span class="value">{{ accidentInfo.happenedPlace || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">事故发生时间</span>
            <span class="value">{{ accidentInfo.happenedTime || '-' }}</span>
          </div>
          <div class="info-item full-width">
            <span class="label">事故情况说明</span>
            <span class="value">{{ accidentInfo.accidentContext || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">事故报告信息</div>
        <a-form :model="formData" layout="vertical" class="edit-form">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="经度" required>
                <a-input-number v-model:value="formData.lon" placeholder="请输入经度" style="width: 100%" :precision="6" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="纬度" required>
                <a-input-number v-model:value="formData.lat" placeholder="请输入纬度" style="width: 100%" :precision="6" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="天气" required>
                <a-select v-model:value="formData.weather" placeholder="请选择天气">
                  <a-select-option :value="1">晴</a-select-option>
                  <a-select-option :value="2">雨</a-select-option>
                  <a-select-option :value="3">雾</a-select-option>
                  <a-select-option :value="4">雪</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="路面状况" required>
                <a-select v-model:value="formData.roadCondition" placeholder="请选择路面状况">
                  <a-select-option :value="1">干燥</a-select-option>
                  <a-select-option :value="2">湿滑</a-select-option>
                  <a-select-option :value="3">结冰</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="事故类型" required>
                <a-select v-model:value="formData.accidentType" placeholder="请选择事故类型">
                  <a-select-option :value="1">碰撞</a-select-option>
                  <a-select-option :value="2">刮擦</a-select-option>
                  <a-select-option :value="3">追尾</a-select-option>
                  <a-select-option :value="4">翻车</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="严重等级" required>
                <a-select v-model:value="formData.severityLevel" placeholder="请选择严重等级">
                  <a-select-option :value="1">一般</a-select-option>
                  <a-select-option :value="2">较大</a-select-option>
                  <a-select-option :value="3">重大</a-select-option>
                  <a-select-option :value="4">特大</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-form-item label="事故说明" required>
            <a-textarea v-model:value="formData.description" placeholder="请输入事故说明" :rows="6" />
            <span class="form-hint">请详细描述事故发生的经过、原因分析及处理措施</span>
          </a-form-item>

          <a-form-item label="事故图片" required>
            <images-uploader
              v-model:imageUrls="formData.images"
              :maxCount="9"
              pathName="incident"
            />
          </a-form-item>

          <a-form-item label="事故发生车辆监控视频" required>
            <videos-uploader
              v-model:videoUrls="formData.videos"
              :maxCount="5"
              pathName="incident"
            />
            <span class="form-hint">要求上传事故发生时前不小于90秒及事故发生后不小于30秒的视频记录，支持上传多个视频文件</span>
          </a-form-item>

          <a-form-item label="事故处理报告">
            <a-upload
              :file-list="formData.handlingReports"
              :before-upload="beforeReportUpload"
              @change="handleReportChange"
              :multiple="true"
              accept=".pdf,.doc,.docx"
            >
              <a-button>
                <upload-outlined></upload-outlined>
                上传事故处理报告
              </a-button>
            </a-upload>
            <span class="form-hint">支持上传PDF、DOC、DOCX格式的事故处理报告文件</span>
            <div v-if="formData.handlingReports && formData.handlingReports.length > 0" class="video-list">
              <div v-for="(report, index) in formData.handlingReports" :key="index" class="video-item">
                <file-text-outlined class="video-icon" />
                <span class="video-name">{{ report.name }}</span>
                <a-button type="text" danger @click="removeReport(index)">删除</a-button>
              </div>
            </div>
          </a-form-item>
        </a-form>
      </div>

      <div class="action-buttons">
        <a-button type="primary" size="large" @click="handleSubmit">提交报告</a-button>
        <a-button size="large" @click="goBack">取消</a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { UploadOutlined, FileTextOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { detailIncident, submitIncident } from '@/api/report/incident';
import imagesUploader from '@/components/imagesUploader/index.vue';
import videosUploader from '@/components/VideosUploader/index.vue';

const router = useRouter();
const route = useRoute();
const accidentInfo = ref({});

const formData = reactive({
  lon: undefined,
  lat: undefined,
  weather: undefined,
  roadCondition: undefined,
  accidentType: undefined,
  severityLevel: undefined,
  description: '',
  images: [],
  accidentTimeRange: null,
  videos: [],
  handlingReports: []
});

const getAccidentTypeText = (type) => {
  const typeMap = { 1: '碰撞', 2: '刮擦', 3: '追尾', 4: '翻车' };
  return typeMap[type] || '-';
};

const loadAccidentDetail = async () => {
  const incidentId = route.query.incidentId;
  if (!incidentId) {
    message.error('缺少事故ID');
    return;
  }
  try {
    const res = await detailIncident(incidentId);
    if (res.code === 200) {
      const data = res.data || {};
      accidentInfo.value = data;
      Object.keys(formData).forEach(key => {
        if (data[key] !== undefined && data[key] !== null) {
          formData[key] = data[key];
        }
      });
    }
  } catch (error) {
    console.error('获取事故详情失败:', error);
    message.error('获取事故详情失败');
  }
};

onMounted(() => {
  loadAccidentDetail();
});

const beforeReportUpload = (file) => {
  const isAllowed = file.type === 'application/pdf' || 
                    file.type === 'application/msword' || 
                    file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  if (!isAllowed) {
    message.error('请上传PDF、DOC或DOCX格式的文件');
    return false;
  }
  const isLt50M = file.size / 1024 / 1024 < 50;
  if (!isLt50M) {
    message.error('文件大小不能超过50MB');
    return false;
  }
  return true;
};

const handleReportChange = (info) => {
  formData.handlingReports = info.fileList;
};

const removeReport = (index) => {
  formData.handlingReports.splice(index, 1);
};

const handleSubmit = async () => {
  try {
    const data = {
      ...formData,
      id: route.query.incidentId
    };
    delete data.accidentTimeRange;
    const res = await submitIncident(data);
    if (res.code === 200) {
      message.success('报告上传成功');
      goBack();
    }
  } catch (error) {
    console.error('提交事故报告失败:', error);
    message.error('提交事故报告失败');
  }
};

const goBack = () => {
  router.push('/testManage/incident');
};
</script>

<style lang="less" scoped>
.edit-page {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 70px - 57px);
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.edit-content {
  background: #F7F8FA;
  border-radius: 8px;
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 24px;
  text-align: center;
}

.info-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E7EF;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;

  &.full-width {
    grid-column: span 3;
  }

  .label {
    font-size: 14px;
    color: #68767E;
    margin-bottom: 8px;
  }

  .value {
    font-size: 14px;
    color: #0A212E;
    font-weight: 500;
  }
}

.edit-form {
  .ant-form-item {
    margin-bottom: 20px;
  }
}

.form-hint {
  display: block;
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}

.video-list {
  margin-top: 12px;
}

.video-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #F7F8FA;
  border-radius: 4px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.video-icon {
  font-size: 18px;
  color: #1890ff;
  margin-right: 10px;
}

.video-name {
  flex: 1;
  font-size: 14px;
  color: #0A212E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
}
</style>